(() => {
  const RATING_SORT_VALUE = 'vf-rating-desc';

  const isRatingSortActive = () => new URL(window.location.href).searchParams.get('sort_by') === RATING_SORT_VALUE;

  const readNumber = (value) => {
    const parsed = Number.parseFloat(value || '0');
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const syncRatingSortState = () => {
    if (!isRatingSortActive()) return;

    document.querySelectorAll(`[data-vf-sort="${RATING_SORT_VALUE}"]`).forEach((input) => {
      if (input instanceof HTMLOptionElement) {
        input.selected = true;
        return;
      }

      if (!(input instanceof HTMLInputElement)) return;
      input.checked = true;

      const option = input.closest('[role="option"]');
      if (!(option instanceof HTMLElement)) return;

      option.parentElement
        ?.parentElement?.querySelectorAll('[role="option"]')
        .forEach((sibling) => sibling.setAttribute('aria-selected', sibling === option ? 'true' : 'false'));
      option.tabIndex = 0;
    });
  };

  const sortByRating = (cards) =>
    cards
      .map((card, index) => ({
        card,
        index,
        vfReviewRating: readNumber(card.dataset.vfReviewRating),
        vfReviewCount: readNumber(card.dataset.vfReviewCount),
      }))
      .sort((left, right) => {
        if (right.vfReviewRating !== left.vfReviewRating) {
          return right.vfReviewRating - left.vfReviewRating;
        }

        if (right.vfReviewCount !== left.vfReviewCount) {
          return right.vfReviewCount - left.vfReviewCount;
        }

        return left.index - right.index;
      })
      .map(({ card }) => card);

  const getCardsForPage = async (resultsList, page) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', 'manual');
    url.searchParams.set('page', page.toString());
    url.searchParams.set('section_id', resultsList.getAttribute('section-id') || '');

    const response = await fetch(url.toString());
    if (!response.ok) return [];

    const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
    return Array.from(documentFragment.querySelectorAll('[ref="grid"] > [ref="cards[]"]'));
  };

  const sortResultsList = async (resultsList) => {
    if (!isRatingSortActive() || resultsList.dataset.vfRatingLoading === 'true') return;

    const grid = resultsList.querySelector('[ref="grid"]');
    if (!(grid instanceof HTMLElement)) return;

    const initialCards = Array.from(grid.querySelectorAll(':scope > [ref="cards[]"]'));
    const cardSignature = initialCards.map((card) => card.dataset.productId).join('|');
    if (grid.dataset.vfRatingSignature === cardSignature) return;

    resultsList.dataset.vfRatingLoading = 'true';
    resultsList.setAttribute('aria-busy', 'true');
    resultsList.querySelectorAll('[ref="viewMorePrevious"], [ref="viewMoreNext"]').forEach((element) => element.remove());

    try {
      const totalPages = Number.parseInt(grid.dataset.lastPage || '1', 10);
      const additionalPages = await Promise.all(
        Array.from({ length: Math.max(totalPages - 1, 0) }, (_, index) => getCardsForPage(resultsList, index + 2)),
      );
      const allCards = [...initialCards, ...additionalPages.flat()];
      const sortedCards = sortByRating(allCards);

      grid.replaceChildren(...sortedCards);
      grid.dataset.vfRatingSignature = sortedCards.map((card) => card.dataset.productId).join('|');
    } catch (error) {
      console.warn('Unable to apply highest-rated product sorting.', error);
    } finally {
      resultsList.dataset.vfRatingLoading = 'false';
      resultsList.removeAttribute('aria-busy');
    }
  };

  const refreshRatingSort = () => {
    syncRatingSortState();

    document.querySelectorAll('results-list').forEach((resultsList) => {
      if (resultsList instanceof HTMLElement) void sortResultsList(resultsList);
    });
  };

  const observer = new MutationObserver(refreshRatingSort);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', refreshRatingSort);
  window.addEventListener('popstate', refreshRatingSort);
  refreshRatingSort();
})();
